import {useEffect} from 'external/react'

import usePayment from 'context/payment-context/hook'

import Summaries from './Summaries'
import PackageItem from './PackageItem'
import usePublic from 'context/public-context/hook'

export default function ShoppingCartSummary() {

	const {packageItem, packageStatus} = usePayment()
	const {navigation} = usePublic()

	useEffect(() => {
		if (!packageItem) return
		if (packageStatus.notFound) {
			navigation.offers.go()
		} else if (packageStatus.missingCourses) {
			navigation.offer.go({offerId: packageItem.offerId})
		}
	}, [packageStatus, navigation])

	return (
		<div className='container'>
			<div className='row mt-5 mb-5'>
				<div className='col-md-12'>
					<div className='shadow card text-center'>
						<div className='card-body'>
							<div className='row'>
								<div className='col-md-12'>
									<div className='d-flex justify-content-between mb-2'>
										<div>
											<span className='fw-bold mr-3'>Carrito de Compras</span>
										</div>
									</div>
								</div>
								<PackageItem />
								<Summaries />
							</div>
						</div>
					</div>
				</div>
			</div>
	</div>
	);
}